<template>
  <div class="space-y-8">
    <GeneralSettings :contact-list="contactList" />
  </div>
</template>

<script>
import GeneralSettings from './components/GeneralSettings.vue';

export default {
  components: {
    GeneralSettings,
  },
  props: {
    contactList: {
      type: Object,
      required: true,
    },
  },
};
</script>
